<template>
  <div>
    <OrderedItemBaseCard
      :name="name ? name : itemName"
      :original-price="item.price"
      :current-price="item.price"
      :clear="!item.isNotAllowedSelect && !isBelongAddOn(item) && showClearButton"
      :show-deal="showDeal"
      :test-name-list="testNameList"
      :test-markup-price-list="testMarkupPriceList"
      :markup-price="markupPrice"
      :customized-test-name-changed="item.customizedName && item.orignalCustomizedName !== item.customizedName"
      :markup-version="item.markupVersion"
      :default-markup-price="item.defaultMarkupPrice"
      :is-for-markup-dialog="isForMarkupDialog"
      :is-show-markup-price="isShowMarkupPrice"
      :is-show-edit-markup="isShowEditMarkup"
      :is-markup-changeable="isMarkupChangeable"
      :show-original-price="paymentMethod !== 'wellProz'"
      @edit-markup="openMarkupEditDialog"
      @add-markup="openMarkupEditDialog"
      @saveMarkup="$emit('saveMarkup', $event)"
      @saveMarkupAsDefault="saveMarkupAsDefault"
      @clear="removeItem(item)"
    >
      <template #original-price>
        <p 
          class="final-price" 
          :class="[
            isForMarkupDialog ? '' 
              : item.isNotAllowedSelect || isBelongAddOn(item) ? 'mr-8': 'mr-2.5',
            showDeal ? 'grey-strikethru':''
            ]"
        >
          {{ currency.symbol + item.price.toFixed(2) }}
        </p>
      </template>
    </OrderedItemBaseCard>
    <MarkupEditDialog 
      v-if="isShowMarkupEditDialog" 
      :is-show-dialog="isShowMarkupEditDialog"
      :item-name="name ? name : itemName"
      :item-category="item.category"
      :item-price="item.price"
      :default-markup-price="item.markupPrice ? Number(item.markupPrice.toFixed(2)) : item.markupPrice"
      :customized-test-name="item.customizedName ? item.customizedName : ''"
      @close="isShowMarkupEditDialog = false"
      @saveMarkup="$emit('saveMarkup', $event)"
    />
  </div>
</template>

<script>
//import PanelCardAllTest from "../AllTestsPannel/PannelCard_AllTest.vue";
// import TestSuggestionDialog from "./TestAddOnSuggestion/TestSuggestionDialog.vue";
import OrderedItemBaseCard from "./OrderedItemBaseCard.vue";
import MarkupEditDialog from './MarkupEditDialog.vue';
import { mapState, mapGetters } from "vuex";
import { postMarkUps } from '@/api/markup';
import { notify } from '@/utils/notify';
import { formatMarkupDataForApi, updateMarkupInfo } from '../order-page/order-summary/selected-tests-tab-pane/index.js';
import { removeItemInSelectedItemList } from "../order-page/order-summary/selected-tests-tab-pane/index.js";
import { getItemNameByLanguage } from "../order-page/order-test-panel/order-test-tabs/testCard";

export default {
  components: {
    OrderedItemBaseCard,
    MarkupEditDialog
    // TestSuggestionDialog
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    testNameList: {
      type: Array,
      default: () => []
    },
    testMarkupPriceList: {
      type: Array,
      default: () => []
    },
    testPriceTotal:{
      type: Number,
      default: 0
    },
    originalPrice: {
      type: Number,
      default: 0
    },
    name: {
      type: String,
      default: ""
    },
    isForMarkupDialog: {
      type: Boolean,
      default: false,
    },
    isShowEditMarkup: {
      type: Boolean,
      default: true
    },
    showClearButton: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      isShowIncludedTests: false,
      isShowTestSuggestionDialog: false,
      isShowMarkupEditDialog: false
    }
  },
  computed: {
    ...mapState(["language"]),
    ...mapState(["currency"]),
    ...mapState("orderTest", ["testSuggestions","isAddOnOrder","addOnFixedVaVwTest","addOnFixedDiscountPanel","addOnFixedCustomPanel","addOnFixedVaVwTestWithParents"]),
    ...mapState("orderTest/user", ["userInfo"]),
    ...mapState("orderTest/order", ["paymentMethod"]),
    ...mapGetters("orderTest/order", ["isMarkupEligible"]),
    ...mapGetters("orderTest", ["selectedVwTestPrice", "orderTestSupportObj", "addOnselectedItemList"]),
    ...mapGetters("orderTest/panels", ["selectedXChooseYPanelList"]),

    itemName() {
      if (["discountPanel", "vw", "va"].includes(this.item.category)) {
        return getItemNameByLanguage(this.item, this.language);
      }
      if (this.item.category === "program") {
        return this.item.displayName || this.item.name;
      }
      return this.item.shortcutName
        ? this.item.shortcutName : this.item.testName
        ? this.item.testName : this.item.discountName;
    },

    displayedOriginalPrice() {
      return this.originalPrice ? this.originalPrice : this.itemOriginalPrice;
    },

    markupPrice() {
      return this.item.markupPrice ? Number(this.item.markupPrice.toFixed(2)) : 0;
    },
 
    // get suggested tests for va or vw test
    testSuggestionList() {
      if (this.item.category === "va" || this.item.category === "vw") {
        return this.testSuggestions.filter(suggestion => suggestion.item_id === this.item.id);
      }
      return [];
    },

    // if x choose y, the original price is total price of the included tests
    // if discount panel, the original price is the original price of the discount panel
    // otherwise the original price is the price of the item
    itemOriginalPrice() {
      switch(this.item.category) {
        case 'xChooseY':
          return this.testPriceTotal;
        case 'discountPanel':
          return this.item.originalPrice ? Number(this.item.originalPrice) : this.item.price;
        default:
          return this.item.price;
      }
    },
    isShowMarkupPrice() {
      // if item is from original order in addon order,
      // then check whether it has markup version as well
      if (this.addOnselectedItemList.addOnSelectedItemList.includes(this.item)) {
        let { markupVersion } = this.item; 
        return this.isMarkupEligible && (markupVersion || markupVersion === 0) ? true : false;
      }
      return this.isMarkupEligible;
    },
    isMarkupChangeable() {
      if (this.item.changeable === false) {
        return false;
      }
      return true;
    },
    showDeal() {
      return false;
    }
  },

  emits: ["removeItem", "saveMarkup"],

  methods: {
    removeItem(item) {
      removeItemInSelectedItemList(item, this.orderTestSupportObj);

      if (item.category === "program") {
        this.$store.dispatch('orderTest/program/removeSelectedProgram', item.id);
      }

      if(this.isAddOnOrder) {
        if(item.category === "va" || this.item.category === "vw") {
          this.$store.dispatch('orderTest/addOnFixedVaVwTestTubeInfo', {root:item,isFixedVaVw:'false',isSelect:'false'})
        }
        else if(item.category === 'discountPanel') {
          let { packageList,testList } = item.bundleContent
          let testIdList = testList ? testList.map(t => t.testId) : [];
          let packageIdList = packageList ? packageList.map(p => p.packageId) : [];
          let bundleContentTesetIds = testIdList.concat(packageIdList)

          bundleContentTesetIds.forEach(x => {
            let root = this.orderTestSupportObj.testNodeList.find(node => node.id === x)
            this.$store.dispatch('orderTest/addOnFixedVaVwTestTubeInfo', {root:root,isFixedVaVw:'false',isSelect:'false'})
          })
        }
        else if(item.category === 'customPanel') {
          this.$store.dispatch('orderTest/addOnFixedVaVwTestTubeInfo', {root:item,isFixedVaVw:'false',isSelect:'false'})
        }
        else if(item.category === 'shortcut') {
          this.$store.dispatch('orderTest/addOnFixedVaVwTestTubeInfo', {root:item,isFixedVaVw:'false',isSelect:'false'})
        }
      }
      this.$emit("removeItem", item);
      
    },

    isBelongAddOn(item) {
      let affectedAddOnDiscountBundle = false
      let affectedAddOnPromo = false
      let affectedAddOnXChooseY = false
      let affectedAddOnVaVwTest = false
      
      if(item.category === 'discountPanel') {
        let { packageList,testList } = item.bundleContent
        let testIdList = testList ? testList.map(t => t.testId) : [];
        let packageIdList = packageList ? packageList.map(p => p.packageId) : [];
        let bundleContentTesetIds = testIdList.concat(packageIdList)

        let addOnFixedVaVwTestKeys = Array.from(this.addOnFixedVaVwTest.keys())
        let addOnFixedVaVwTestValues = Array.from(this.addOnFixedVaVwTest.values())
        
        if(addOnFixedVaVwTestKeys.concat(addOnFixedVaVwTestValues).some(x => bundleContentTesetIds.includes(x))) {
          affectedAddOnDiscountBundle = true
        }
        return this.addOnFixedDiscountPanel.has(item.bundleId) || affectedAddOnDiscountBundle
      }
      else if(item.category === 'seasonalPromo') {
        let addOnFixedVaVwTestKeys = Array.from(this.addOnFixedVaVwTest.keys())
        let addOnFixedVaVwTestValues = Array.from(this.addOnFixedVaVwTest.values())
        if(addOnFixedVaVwTestKeys.concat(addOnFixedVaVwTestValues).some(x => item.testIdsInPromo.has(x))) {
          affectedAddOnPromo = true
        }
        return affectedAddOnPromo
      }
      else if(item.category === 'xChooseY') {
        let addOnFixedVaVwTestKeys = Array.from(this.addOnFixedVaVwTest.keys())
        let addOnFixedVaVwTestValues = Array.from(this.addOnFixedVaVwTest.values())
        
        if(addOnFixedVaVwTestKeys.concat(addOnFixedVaVwTestValues)
          .some(x => (item.selectedZoomerIdList).includes(x) || (item.selectedSupplementIdList&&item.selectedSupplementIdList.includes(x)))) {
            affectedAddOnXChooseY = true
        }
        return affectedAddOnXChooseY
      }
      else if(item.category === 'va' || item.category === 'vw') {
        if(this.addOnFixedVaVwTestWithParents.get(item.id)) {
          affectedAddOnVaVwTest = true
        }
        return this.addOnFixedVaVwTest.has(item.id) || affectedAddOnVaVwTest
      }
      else if(item.category === 'customPanel') {
        return this.addOnFixedCustomPanel.includes(item.bundleId)
      } else {
        return false
      }
    },

    async saveMarkupAsDefault() {
      const { data, newDefaultMarkupPrice, affiliate_id } = formatMarkupDataForApi(this.markupPrice, this.item, this.userInfo)
      try {
        await postMarkUps(data);
      } catch (error) {
        console.error(error);
        return;
      } 
      updateMarkupInfo(newDefaultMarkupPrice, this.item);
    },

    openMarkupEditDialog() {
      if (this.isMarkupChangeable) {
        this.isShowMarkupEditDialog = true;
      } else {
        notify({ type: 'error', message: 'This item is not allowed add/edit retail by the clinic admin' });
      }
    }
  }
};
</script>

<style scoped>
.final-price {
  height: 16px;
  font-size: 14px;
  letter-spacing: 0.4px;
  line-height: 16px;
}

.grey-strikethru {
  color: grey;
  text-decoration: line-through;
}

.deal-price {
  height: 16px;
  color: #000000;
  font-family: Roboto;
  font-size: 14px;
  letter-spacing: 0.4px;
  line-height: 16px;
  /* margin-right: 31px; */
}

.unlocking-deal-container {
  background-color: rgba(132, 188, 59, 0.05);
  width: 349px;  
  height: 30px;
  padding-right: 8px;
}

.save-text{
  color: #FF1D00;
}
</style>
